import TumengValuationEdit from './src/index.vue'

TumengValuationEdit.install = function(Vue) {
  Vue.component(TumengValuationEdit.name, TumengValuationEdit)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengValuationEdit)
}

export default TumengValuationEdit
